setInterval(() => {
  const elements = document.querySelectorAll(".upcart-item-property");

  elements.forEach((element) => {
    const content = element.textContent || element.innerText;
    if (
      content.includes("_customization_id") ||
      content.includes("customization_id") ||
      content.includes("_customization_image") ||
      content.includes("_tib_design_link_1")
    ) {
      element.remove();
    }
  });
}, 100);

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(
    "div[data-product-blocks] .product__policies"
  );
  console.log("elementToMove", elementToMove);
  const insertAfterElement = document.querySelector(
    ".teeinblue-enabled .tee-product-price"
  );
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});
